import { isArray, isFunction } from './typeguards.js';

/**
 * A push implementation which imediately executes the pushed functions.
 *
 * @param funcs functions to execute
 * @returns always 0 as the queue array is empty
 */
function push(...funcs: Array<Function | undefined>): number {
    for (const func of funcs.filter(isFunction)) {
        try {
            func();
        } catch (error) {
            console.trace('Error in queued function: %o, source: %o', error, func.toString());
        }
    };
    return 0;
}

/**
 * Process a queue by executing functions in the preserved order.
 * When the queue is empty we replace the push fuction to execute future queued functions imediatelly.
 *
 * Note: we need to work and replace on the original object instead of working on a copy
 *       as other scripts might keep references of the variable
 *
 * @param cmd The queue to process.
 */
export function processAndReplaceQueue(cmd: Array<Function>): void {
    if (isArray(cmd)) {
        while (cmd.length > 0) {
            let next = cmd.shift();
            push(next);
        }
        cmd.push = push;
    }
}
